
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CateringOrdersCart from "./CateringOrdersCart";
import CateringSidescrollAdvertisements from "./CateringSidescrollAdvertisements";
import axios from "axios";
import menu1 from "./menu1.jpg";


const CateringsCartdata = () => {
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [filteredItems, setFilteredItems] = useState([]);
    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const isMobile = window.innerWidth <= 768;

    useEffect(() => {
        fetchCartDataFromAPI();
        setBannerData({
            companyName: "Maamaas Catering",
            vendorId: 1
        });
    }, []);



    const fetchCartDataFromAPI = async () => {
        try {
            const userId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken");

            if (!userId || !token) {
                console.log("User not logged in");
                setLoading(false);
                return;
            }

            const response = await axios.get(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/cart/${userId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("📦 RAW API Cart Data:", response.data);

            if (response.data && Array.isArray(response.data)) {
                // Get cart data with images from localStorage
                const localCart = JSON.parse(localStorage.getItem('cateringCart') || '[]');
                console.log("🖼️ LocalStorage cart data:", localCart);

                const transformedCartData = [];
                response.data.forEach(order => {
                    if (order.items && Array.isArray(order.items)) {
                        order.items.forEach(item => {
                            // Find matching item in localStorage to get the image
                            const localItem = localCart.find(local =>
                                local.packageId === item.packageId ||
                                local.packageId?.toString() === item.packageId?.toString()
                            );

                            console.log(`🔍 Looking for packageId ${item.packageId} in localStorage:`, localItem);

                            const price = parseFloat(item.packagePrice) || 0;
                            const quantity = parseInt(item.quantity) || 1;

                            transformedCartData.push({
                                packageId: item.packageId,
                                packageName: item.packageName,
                                packageType: item.packageType || "General",
                                price: price,
                                quantity: quantity,
                                image: localItem ? localItem.image : null, // ✅ Get image from localStorage
                                cateringDate: order.cateringDate,
                                cateringTime: order.cateringTime,
                                cartId: order.id,
                                vendorId: item.vendorId,
                                items: item.packageItems || []
                            });
                        });
                    }
                });

                console.log("✅ FINAL Cart Data with Images:", transformedCartData);
                setCartData(transformedCartData);
                setFilteredItems(transformedCartData);

                const categories = [...new Set(transformedCartData.map(item => item.packageType || "General"))];
                setAllCategories(["Allcarts", ...categories]);

                // Update localStorage with the merged data
                localStorage.setItem('cateringCart', JSON.stringify(transformedCartData));
            }
        } catch (error) {
            console.error("❌ Error fetching cart data from API:", error);
            loadCartDataFromLocalStorage();
        } finally {
            setLoading(false);
        }
    };

    const loadCartDataFromLocalStorage = () => {
        const cart = JSON.parse(localStorage.getItem('cateringCart') || '[]');
        console.log("📥 Loading from localStorage:", cart);

        setCartData(cart);
        setFilteredItems(cart);

        const categories = [...new Set(cart.map(item => item.packageType || "General"))];
        setAllCategories(["Allcarts", ...categories]);
        setLoading(false);
    };


    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        if (category === "Allcarts") {
            setFilteredItems(cartData);
        } else {
            const filtered = cartData.filter(item => item.packageType === category);
            setFilteredItems(filtered);
        }
    };

    
    const getCategoryImage = (category) => {
        // ✅ Step 1: If "Allcarts", show general image
        if (category === "Allcarts") return menu1;

        // ✅ Step 2: Try to find matching image in current cartData
        const cartItem = cartData.find(item => item.packageType === category && item.image);
        if (cartItem && cartItem.image) return cartItem.image;

        // ✅ Step 3: Fallback — read from localStorage cateringCart (from CateringItems)
        const localCart = JSON.parse(localStorage.getItem('cateringCart') || '[]');
        const localMatch = localCart.find(item => item.packageType === category && item.image);
        if (localMatch && localMatch.image) return localMatch.image;

        // ✅ Step 4: Final fallback
        return menu1;
    };


    const getCompanyName = () => {
        return bannerData?.companyName || "Maamaas Catering";
    };

    if (loading) {
        return (
            <div className="container-fluid" style={{ marginTop: "100px", textAlign: "center" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p style={{ marginTop: "15px" }}>Loading your catering cart...</p>
            </div>
        );
    }

    return (
        <div className="container-fluid">

        
            <div className="row" style={{ marginTop: "50px", overflow: "hidden" }}>

                {/* Sidebar - Category Navigation */}
                <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                    <div
                        className="category-sidebar d-none d-sm-block  mobile-scrolling-cart"
                        style={{
                            position: "sticky",
                            maxHeight: "600px",
                            top: "0px",
                            marginTop: "5px",
                            height: "100vh",
                            overflowY: "auto",
                            scrollbarWidth: 'none',
                            width: "180px",
                             msOverflowStyle: "none",
                        }}
                    >
                        <div className="category-container" style={{ overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none", }}>
                            {allCategories.map((category, index) => (
                                <div
                                    key={index}
                                    className="category-card"
                                    onClick={() => handleCategoryClick(category)}
                                    style={{
                                        backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                        margin: "8px 0",
                                        padding: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        borderRadius: "15px",
                                        transition: "0.3s ease-in-out",
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                        height: "165px",
                                    }}
                                >
                                    <img
                                        src={getCategoryImage(category)}
                                        alt={category}
                                        style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            backgroundColor: "#f0f0f0"
                                        }}
                                        onError={(e) => {
                                            e.target.src = "/images/default-category.jpg";
                                        }}
                                    />
                                    <div className="category-card-body d-flex justify-content-center p-0">
                                        <button
                                            style={{
                                                backgroundColor: activeCategory === category ? "#ddd" : "#fff",
                                                margin: "5px",
                                                padding: "8px",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                transition: "0.3s ease-in-out",
                                                border: "none",
                                                fontSize: "12px",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            {category}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div
                    className="col-lg-7 col-md-7 col-sm-12 col-12"
                    style={{
                        maxHeight: "100vh",
                        scrollbarWidth: "none",
                        overflowY: "auto",
                    }}
                >
                    {/* Breadcrumb */}
                    <p
                        className="breadcrumb maamaas-home-bredcums"
                        style={{
                            marginTop: "40px",
                            fontSize: "18px",
                            marginLeft: "20px",

                        }}
                    >
                        <Link to="/" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Home
                        </Link>
                        <span className="separator"> &gt; &gt; </span>
                        <Link to="/cateringHomemaamaas" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            {getCompanyName()}
                        </Link>
                        <span className="separator"> &gt; &gt; </span>
                        <Link to="" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Catering Cart
                        </Link>
                    </p>

                    {/* Mobile Dropdown */}
                    <div className="d-block d-sm-none" style={{ marginTop: "20px", width: "100%", padding: "0 15px" }}>
                        <select
                            className="form-control"
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "10px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#ee6521",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "16px"
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Cart Items Display */}
                    <div
                        className="cartsizes"
                        style={{
                            marginTop: "-10px",
                            padding: "0px",
                            borderRadius: "8px",
                        }}
                    >
                        <CateringOrdersCart
                            filteredDataProp={filteredItems}
                            onCartUpdate={fetchCartDataFromAPI}
                        />
                    </div>
                </div>

                {/* Advertisement Sidebar */}
                {!isMobile && (
                    <div className="col-lg-3">
                        <CateringSidescrollAdvertisements />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CateringsCartdata;












